/* Generated from Java with JSweet 2.3.5 - http://www.jsweet.org */
import { Library } from '../../Library';
import { AbstractCommand } from '../AbstractCommand';
import { LoggerCompat } from '../../compat/LoggerCompat';
import { Document } from '../../core/models/Document';
import { Node } from '../../core/models/Node';
import { NodePath } from '../../core/models/NodePath';
import { ISecurityRequirementParent } from '../../core/models/common/ISecurityRequirementParent';
import { SecurityRequirement } from '../../core/models/common/SecurityRequirement';
import { MarshallCompat } from '../../compat/MarshallCompat';

/**
 * A command used to create a new security requirement in a document.
 * @author eric.wittmann@gmail.com
 * @extends AbstractCommand
 * @class
 */
export class AddSecurityRequirementCommand extends AbstractCommand {
    public _parentPath : NodePath;

    public _requirement : any;

    public _added : boolean;

    public constructor(parent? : any, requirement? : any) {
        if(((parent != null && (parent["__interfaces"] != null && parent["__interfaces"].indexOf("io.apicurio.datamodels.core.models.common.ISecurityRequirementParent") >= 0 || parent.constructor != null && parent.constructor["__interfaces"] != null && parent.constructor["__interfaces"].indexOf("io.apicurio.datamodels.core.models.common.ISecurityRequirementParent") >= 0)) || parent === null) && ((requirement != null && requirement instanceof <any>SecurityRequirement) || requirement === null)) {
            let __args = arguments;
            super();
            if(this._parentPath===undefined) this._parentPath = null;
            if(this._requirement===undefined) this._requirement = null;
            if(this._added===undefined) this._added = false;
            if(this._parentPath===undefined) this._parentPath = null;
            if(this._requirement===undefined) this._requirement = null;
            if(this._added===undefined) this._added = false;
            (() => {
                this._parentPath = Library.createNodePath(<Node><any>parent);
                this._requirement = Library.writeNode(requirement);
            })();
        } else if(parent === undefined && requirement === undefined) {
            let __args = arguments;
            super();
            if(this._parentPath===undefined) this._parentPath = null;
            if(this._requirement===undefined) this._requirement = null;
            if(this._added===undefined) this._added = false;
            if(this._parentPath===undefined) this._parentPath = null;
            if(this._requirement===undefined) this._requirement = null;
            if(this._added===undefined) this._added = false;
        } else throw new Error('invalid overload');
    }

    /**
     * @see io.apicurio.datamodels.cmd.ICommand#execute(io.apicurio.datamodels.core.models.Document)
     * @param {Document} document
     */
    public execute(document : Document) {
        LoggerCompat.info("[AddSecurityRequirementCommand] Executing.");
        this._added = false;
        let parent : ISecurityRequirementParent = <ISecurityRequirementParent><any>this._parentPath.resolve(document);
        if(this.isNullOrUndefined(parent)) {
            return;
        }
        let requirement : SecurityRequirement = parent.createSecurityRequirement();
        Library.readNode(this._requirement, requirement);
        parent.addSecurityRequirement(requirement);
        this._added = true;
    }

    /**
     * @see io.apicurio.datamodels.cmd.ICommand#undo(io.apicurio.datamodels.core.models.Document)
     * @param {Document} document
     */
    public undo(document : Document) {
        LoggerCompat.info("[AddSecurityRequirementCommand] Reverting.");
        if(!this._added) {
            return;
        }
        let parent : ISecurityRequirementParent = <ISecurityRequirementParent><any>this._parentPath.resolve(document);
        if(this.isNullOrUndefined(parent)) {
            return;
        }
        let security : Array<SecurityRequirement> = parent.getSecurityRequirements();
        if(this.isNullOrUndefined(security)) {
            LoggerCompat.info("[AddSecurityRequirementCommand] Security requirement not found, skipping undo.");
            return;
        }
        let requirement : SecurityRequirement = parent.createSecurityRequirement();
        Library.readNode(this._requirement, requirement);
        let idx : number = this.indexOfRequirement(security, requirement);
        if(idx !== -1) {
            /* remove */security.splice(idx, 1)[0];
        }
    }

    indexOfRequirement(requirements : Array<SecurityRequirement>, requirement : SecurityRequirement) : number {
        let idx : number = 0;
        for(let index166=0; index166 < requirements.length; index166++) {
            let r = requirements[index166];
            {
                if(this.isEqual(r, requirement)) {
                    return idx;
                }
                idx++;
            }
        }
        return -1;
    }

    isEqual(req1 : SecurityRequirement, req2 : SecurityRequirement) : boolean {
        let names1 : Array<string> = req1.getSecurityRequirementNames();
        let names2 : Array<string> = req2.getSecurityRequirementNames();
        if(/* size */(<number>names1.length) !== /* size */(<number>names2.length)) {
            return false;
        }
        let rval : boolean = true;
        for(let index167=0; index167 < names1.length; index167++) {
            let name1 = names1[index167];
            {
                if(names2.indexOf(name1) === -1 || !this.areScopesEqual(req1.getScopes(name1), req2.getScopes(name1))) {
                    rval = false;
                }
            }
        }
        return rval;
    }

    areScopesEqual(scopes1 : Array<string>, scopes2 : Array<string>) : boolean {
        if(/* size */(<number>scopes1.length) !== /* size */(<number>scopes2.length)) {
            return false;
        }
        let rval : boolean = true;
        for(let index168=0; index168 < scopes1.length; index168++) {
            let scope1 = scopes1[index168];
            {
                if(scopes2.indexOf(scope1) === -1) {
                    rval = false;
                }
            }
        }
        return rval;
    }
}
AddSecurityRequirementCommand["__class"] = "io.apicurio.datamodels.cmd.commands.AddSecurityRequirementCommand";
AddSecurityRequirementCommand["__interfaces"] = ["io.apicurio.datamodels.cmd.ICommand"];




